export const getDisableInterrupt = () => {
  const isIPhone = /iPhone/i.test(navigator.userAgent);
  const isIPad =
    /iPad/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isMobileFirefox = /Firefox\/\d+\.\d+.*Mobile/i.test(navigator.userAgent);

  const isMacBook =
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints <= 1 && // MacBook не имеет сенсорного экрана
    !/iPhone|iPad|iPod/i.test(navigator.userAgent); // Исключаем iOS-устройства

  // console.log(
  //   "isIPhone:",
  //   isIPhone,
  //   "isIPad:",
  //   isIPad,
  //   "isMobileFirefox:",
  //   isMobileFirefox,
  //   "isMacBook:",
  //   isMacBook
  // );

  return isIPhone || isIPad || isMobileFirefox || isMacBook;
};
